import outcloseLogo from "@/assets/icons/outclose_background.png";
import { ProfileImage } from "@/components/ProfileImage";
import type { ClubAPI } from "@shared/types/api";

const BOX = { xs: "w-6 h-6", sm: "w-8 h-8" } as const;

/** The Outclose logo avatar — same treatment as system messages in chat. */
export function OutcloseAvatar({ size = "sm" }: { size?: keyof typeof BOX }) {
  return (
    <div className={`${BOX[size]} rounded-full bg-primary-100 dark:bg-primary-900/40 flex items-center justify-center overflow-hidden flex-shrink-0`}>
      <img src={outcloseLogo} alt="Outclose" className={`${BOX[size]} object-contain rounded-full`} />
    </div>
  );
}

/** Author avatar for a club post: the Outclose logo for admin posts, the member's photo otherwise. */
export function ClubAuthorAvatar({ post, size = "sm" }: { post: ClubAPI.ClubPost; size?: keyof typeof BOX }) {
  if (post.isAdminPost) return <OutcloseAvatar size={size} />;
  return (
    <ProfileImage
      size={size}
      user={{ firstName: post.author?.firstName, profileImageUrl: post.author?.profileImageUrl }}
    />
  );
}
